<template>
  <DialogContainer v-model="dialogObj" v-if="dialogObj.show">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <custom-map
          ref="amap"
          :clickable="true"
          :init-position="form"
          @position-change="handlePositionChange"></custom-map>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import CustomMap from "@/components/CustomMap.vue";
export default {
  name: "AddPosition",
  components: {
    CustomMap,
    DialogContainer,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "70%",
        show: false,
        title: "选择详细地址",
        confirmTxt: "确认详细地址",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        lng: "",
        lat: "",
        address: "",
        cityCode: "",
        cityName: "",
        districtCode: "",
        districtName: "",
        provinceCode: "",
        provinceName: "",
      },
    };
  },
  mounted() {},
  methods: {
    init(type, item, index) {
      this.form.provinceCode = item.provinceCode;
      this.form.provinceName = item.provinceName;
      this.form.cityCode = item.cityCode;
      this.form.cityName = item.cityName;
      this.form.districtCode = item.districtCode;
      this.form.districtName = item.districtName;
      if (item.lng) {
        this.form.lng = item.lng;
        this.form.lat = item.lat;
        this.form.address = item.address;
      } else {
        this.form.lng = ""
        this.form.lat = ""
        this.form.address = ""
      }
      this.type = type;
      this.index = index;
      this.dialogObj.show = true;
    },
    clearMarker() {
      this.$refs.amap.clearMarker();
    },
    handlePositionChange(position) {
      // // console.log(position);
      this.form.lng = position.location.lng;
      this.form.lat = position.location.lat;
      this.form.address = position.address;
    },
    // 提交数据
    submitForm() {
      if (!this.form.lng) {
        this.$message.warning("请搜索或者点击地图选择")
        return
      }
      let detail = {
        lng: this.form.lng,
        lat: this.form.lat,
        address: this.form.address,
        type: this.type,
        index: this.index,
      };
      this.$emit("positionChange", detail);
      this.dialogObj.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
}
</style>
